// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { FacilityEvent, IFacilityEvent } from "./FacilityEvent.gen";

export interface IOrganizationEventLookup {
	organizationId: string | undefined;

	event: IFacilityEvent | undefined;

	$type?: string | undefined;
}
export class OrganizationEventLookup {
	constructor(data?: IOrganizationEventLookup) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.event) { this.event = new FacilityEvent(data.event); }
	}

	organizationId: string | undefined;

	event: FacilityEvent | undefined;

	static $type: string = "CoreApi.Models.OrganizationEventLookup, ";
	$type?: string | undefined = OrganizationEventLookup.$type;
}

